import { Row, Col, Container } from "react-bootstrap";
import "../cvtemplates.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CVTemplate1 from "../CVtemplate1/components/CVImg";
import CVTemplate2 from "../CVtemplate2/components/CVImg2";
import CVTemplate3 from "../CVtemplate3/components/CVImg3";
import CVTemplate4 from "../CVtemplate4/components/CVImg4";
import CVTemplate5 from "../CVtemplate5/components/CVImg5";
import { useSelector } from "react-redux";
import { useGetCvFormQuery } from "../../../features/user/userApiSlice";
import { useParams } from "react-router-dom";
import BackArrow from "../../../components/backArrow";
import { decodeId } from "../../../utils/idObfuscator";

const CVTemplatesbuyside = () => {
  const { name } = useSelector((state) => state.user);
  const { id: rawId } = useParams();
  const id = decodeId(rawId) || rawId;

  // Use RTK Query instead of axios
  const {
    data: cvDataRes,
    isLoading,
    isFetching,
    isError,
    error,
  } = useGetCvFormQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,
  });
  const cvdata = cvDataRes?.cvform;

  const getCVTemplateComponent = (template) => {
    const templateStr = String(template ?? "0");
    switch (templateStr) {
      case "0":
        return <CVTemplate1 cvdata={cvdata} />;
      case "1":
        return <CVTemplate2 cvdata={cvdata} />;
      case "2":
        return <CVTemplate3 cvdata={cvdata} />;
      case "3":
        return <CVTemplate4 cvdata={cvdata} />;
      case "4":
        return <CVTemplate5 cvdata={cvdata} />;
      default:
        return <CVTemplate1 cvdata={cvdata} />;
    }
  };

  const renderContent = () => {
    // No id in URL — invalid route
    if (!id) {
      return (
        <h5 className="text-center text-danger mt-5">
          Invalid link. No candidate ID provided.
        </h5>
      );
    }

    // Actively fetching
    if (isLoading || isFetching) {
      return (
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 text-muted">Loading CV...</p>
        </div>
      );
    }

    // API returned an error (network issue, 404, 500, etc.)
    if (isError) {
      const is401 = error?.status === 401;
      return (
        <h5 className="text-center text-danger mt-5">
          {is401
            ? "Please log in to view this candidate's CV."
            : "Could not load CV. The candidate may not have created a CV yet."}
        </h5>
      );
    }

    // Data loaded but no CV found for this user
    if (!cvdata) {
      return (
        <h5 className="text-center text-secondary mt-5">
          No CV found for this candidate.
        </h5>
      );
    }

    // All good — render the CV template
    return <div className="cv-slide">{getCVTemplateComponent(cvdata?.template)}</div>;
  };

  return (
    <Row>
      <div className="screenHeight">
        <Container>
          <Row>
            <Col lg="1">
              <BackArrow />
            </Col>
            <Col md={10} lg={9} className="ms-auto">
              {renderContent()}
            </Col>
          </Row>
        </Container>
      </div>
    </Row>
  );
};
export default CVTemplatesbuyside;
